import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { PropertyGeospatialSitadelDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-property-sitadel-card',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule],
  templateUrl: './sitadel-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertySitadelCardComponent {
  sitadel = input<PropertyGeospatialSitadelDto | null | undefined>();
  expanded = model<boolean>(false);

  pressureStepIndex = computed(() => {
    const level = this.sitadel()?.pressureLevel;
    switch (level) {
      case 'low':
        return 0;
      case 'moderate':
        return 1;
      case 'high':
        return 2;
      default:
        return -1;
    }
  });

  pressureInfo = computed(() => {
    const level = this.sitadel()?.pressureLevel;
    switch (level) {
      case 'low':
        return {
          label: 'Pression faible',
          classes: 'bg-jade-a2 text-jade-11 border-jade-a4',
          dotBg: 'bg-jade-9',
          description:
            'Secteur calme avec peu de chantiers récents : cadre de vie établi et stabilité résidentielle.',
        };
      case 'moderate':
        return {
          label: 'Pression modérée',
          classes: 'bg-blue-a2 text-blue-11 border-blue-a4',
          dotBg: 'bg-blue-9',
          description: 'Développement immobilier continu et équilibré : dynamisme urbain sans saturation.',
        };
      case 'high':
        return {
          label: 'Pression élevée',
          classes: 'bg-orange-a2 text-orange-11 border-orange-a4',
          dotBg: 'bg-orange-9',
          description: 'Secteur en mutation avec d’importants programmes neufs en cours ou autorisés.',
        };
      default:
        return null;
    }
  });
}
